import {
  Configuration,
  InteractionRequiredAuthError,
  LogLevel,
} from '@azure/msal-browser';
import { getMsalInstance } from '../services/authentication/msalInstance';
import { getSettings } from '../services/settingsService';

export const getMsalConfiguration = (): Configuration => {
  const settings = getSettings();
  if (!settings.clientId) {
    const errMsg =
      'A client ID has to be provived in the enviroment variables.';
    console.error(errMsg);
    throw new Error(errMsg);
  }
  if (!settings.loginInstance) {
    const errMsg =
      'A LOGIN_INSTANCE has to be provived in the enviroment variables.';
    console.error(errMsg);
    throw new Error(errMsg);
  }
  if (!settings.tenantId) {
    const errMsg =
      'A tenant ID has to be provived in the enviroment variables.';
    console.error(errMsg);
    throw new Error(errMsg);
  }
  if (!settings.signInSignOutPolicy) {
    const errMsg =
      'A SIGN_IN_SIGN_OUT_POLICY has to be provived in the enviroment variables.';
    console.error(errMsg);
    throw new Error(errMsg);
  }

  const configuration: Configuration = {
    auth: {
      clientId: settings.clientId,
      authority: `${settings.loginInstance}${settings.tenantId}/${settings.signInSignOutPolicy}`,
      knownAuthorities: [`${settings.loginInstance}`],
      redirectUri: window.location.origin,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'localStorage',
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
            default:
              return;
          }
        },
      },
    },
  };
  return configuration;
};

export const adquireTokenSilent = async (): Promise<string> => {
  const msalInstance = await getMsalInstance();

  const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
  const accounts = msalInstance.getAllAccounts();

  if (!activeAccount && accounts.length === 0) {
    console.error('User is not signed in.');
    msalInstance.loginRedirect({
      authority: getMsalConfiguration().auth.authority,
      scopes: getAuthorizationScopes(),
      redirectStartPage: window.location.href,
    });
  }

  const request = {
    scopes: [...getAuthorizationScopes()],
    account: activeAccount || accounts[0],
  };

  try {
    const authResult = await msalInstance.acquireTokenSilent(request);
    return authResult.accessToken;
  } catch (err) {
    console.log('Error in adquireTokenSilent - acquireTokenSilent', err);
    if (err instanceof InteractionRequiredAuthError) {
      msalInstance.loginRedirect({
        authority: getMsalConfiguration().auth.authority,
        scopes: getAuthorizationScopes(),
        redirectStartPage: window.location.href,
      });
    }
    return '';
  }
};

export const getAuthorizationScopes = (): string[] => {
  const settings = getSettings();
  if (!settings.loginScopes) {
    const errMsg =
      'An arrray of login scopes has to be provived in the enviroment variables.';
    console.error(errMsg);
    throw new Error(errMsg);
  }
  if (!settings.loginScopesSeparator) {
    const errMsg =
      'A separator for the login scopes array has to be provived in the enviroment variables.';
    console.error(errMsg);
    throw new Error(errMsg);
  }
  return settings.loginScopes.split(settings.loginScopesSeparator);
};
